export default "__VITE_ASSET__Ca1A0vSZ__"